import React, { useEffect, useState, useRef } from "react";
import {
  Tooltip,
  makeStyles,
  Avatar,
  TableCell,
  TableRow,
  TableCellLayout,
  PopoverTrigger,
  Popover,
  PopoverSurface,
} from "@fluentui/react-components";
import { useHistory } from "react-router-dom";
import useNavigation from "../../../../../utils/useNavigation";
import {
  FlagIcon,
  MeatBallsMenuIcon,
  PendingDeleteIcon,
  PlusIcon,
} from "../../../../../modules/default-svg";
import HoverCard from "../../../../hoverCard/HoverCard";
import {
  utcToLocalDateString,
  dateOnlyFormatted,
  getAccountCurrency,
  displayDecimalFormatted,
} from "../../../../../utils/systemSettings";
import CustomInput from "../../../input/customInput/CustomInput";
import CustomSelect from "../../../select/CustomSelect";
import userService from "../../../../../store/services/user.service";
import {
  createPortFolioRequest,
  updatePortFolioRequest,
} from "../../../../../store/actions/portfolio.actions";
import { useDispatch } from "react-redux";
import clientService from "../../../../../store/services/clients.service";
import { generalActions } from "../../../../../store/actions";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const useStyles = makeStyles({
  tooltip: {
    backgroundColor: "#342c82",
    color: "#FFFFFF",
  },
});

const PortFolioRow = (props) => {
  const {
    sortingCriteria,
    data,
    handleModal,
    menu,
    sortPortfoliosRequest,
    parentType,
    clientId,
    updateFlag,
    columnConfig,
    overviewType,
    dashboardFilterSetId,
    dashboardFilterSetName,
    loadingSkeleton,
    dashboardFilterId
  } = props;
  const settings = JSON.parse(localStorage.getItem("settings"));
  const [flagged, setFlagged] = useState([]);
  const [sortedData, setSortedData] = useState([]);
  const [popoverOpen, setPopoverOpen] = useState({});
  const [ownerId, setOwnerId] = useState("");
  const [resources, setResources] = useState([]);
  const portfolioNameInputRef = useRef(null);
  const portfolioManagerInputRef = useRef(null);
  const budgetInputRef = useRef(null);
  const statusInputRef = useRef(null);
  const riskLevelInputRef = useRef(null);
  const startDateInputRef = useRef(null);
  const endDateInputRef = useRef(null);
  const clientInputRef = useRef(null);
  const history = useHistory();
  const { navigateTo } = useNavigation();
  const popoverRef = useRef(null);
  const [setting] = useState(settings);
  const dispatch = useDispatch();

  const [clients, setClients] = useState([]);
  const [isEditRecord, setIsEditRecord] = useState(null);
  const [formErrors, setFormErrors] = useState({
    name: "",
  });

  const handleBlur = () => {
    let data = { ...isEditRecord.name };
    if (data?.owner) {
      data.ownerId = data.owner.id;
    } else {
      data.ownerId = null;
    }
    if (data?.client) {
      data.clientId = data.client.id;
    } else {
      data.clientId = null;
    }
    const payload = {};
    if (clientId) {
      payload.clientId = clientId;
      data.clientId = clientId;
    }
    if (
      data.name &&
      data.clientId &&
      (data.startDate && data.endDate ? data.endDate > data.startDate : true)
    ) {
      if (data.id) {
        dispatch(
          updatePortFolioRequest({
            id: sortedData[isEditRecord.index].id,
            payload: data,
            ...payload,
          })
        );
      } else {
        dispatch(createPortFolioRequest({ payload: data, ...payload }));
      }
      setIsEditRecord(null);
    } else {
      let errors = {};
      if (!data.name) {
        errors["name"] = "Name is a required Field";

        return dispatch(
          generalActions.showToast({
            title: "name is a required field",
            type: "error",
          })
        );
      }
      if (!data.client) {
        errors["client"] = "Client is a required Field";
        dispatch(
          generalActions.showToast({
            title: "Client is a required field",
            type: "error",
          })
        );
      }
      if (data.startDate > data.endDate) {
        errors["startDate"] = "Start date can not be greater than end date";
        errors["endDate"] = "Start date can not be greater than end date";
        dispatch(
          generalActions.showToast({
            title: "Start date can not be greater than end date",
            type: "error",
          })
        );
      }
      setFormErrors(errors);
    }
  };

  const handleEditable = (event) => {
    if (event.key === "Escape") {
      setIsEditRecord(null);
    } else if (event.key === "Enter") {
      if (isEditRecord) {
        handleBlur();
      }
    }
  };

  const handleClientRedirect = (item) => {
    if (parentType !== "Client") {
      // Use navigation hook for direct navigation to client
      navigateTo("Clients", item.client.id, item.client.name);
    } else {
      // Already in client context, just navigate
      history.push(`/clients/${item.client.id}/overview`);
    }
  };

  useEffect(() => {
    if (sortingCriteria.column !== null) {
      if (parentType === "Client") {
        sortPortfoliosRequest({
          id: clientId,
          page: 1,
          size: 10,
          orderBy: `${sortingCriteria.column} ${sortingCriteria.order}`,
        });
      } else {
        sortPortfoliosRequest({
          page: 1,
          size: 10,
          orderBy: `${sortingCriteria.column} ${sortingCriteria.order}`,
        });
      }
    }
  }, [sortingCriteria]);

  useEffect(() => {
    if (typeof data != "string") {
      data
        .filter((d) => d.isFlagged)
        .map((f) => {
          if (!flagged.includes(f.id)) {
            setFlagged((prevItems) => [...prevItems, f.id]);
          }
        });
      const tempDate = [...data];
      tempDate.push({
        name: "",
        client: null,
        owner: null,
        status: "",
        budget: 0,
        startDate: "",
        endDate: "",
        riskLevel: "",
      });
      setSortedData(tempDate);
    }
  }, [data]);

  const handleRedirect = (item) => {
    if (overviewType === "Dashboard") {
      dashboardFilterSetId(item.id);
      dashboardFilterSetName(item.name);
      return;
    }
    // Use navigation hook instead of localStorage
    navigateTo("Portfolios", item.id, item.name);
  };

  useEffect(() => {
    if (menu.props.closePopover) {
      setPopoverOpen(null);
    }
  }, [menu.props.closePopover]);

  const handlePopoverOpen = (rowId) => {
    setPopoverOpen(rowId);
  };

  const handleClickOutside = (event) => {
    if (
      popoverRef.current &&
      !popoverRef.current.contains(event.target) &&
      event.target?.innerText !== "Edit" &&
      event.target?.innerText !== "Delete" &&
      event.target?.innerText !== "Remind me" &&
      event?.target?.tagName !== "svg"
    ) {
      if (popoverOpen) {
        handlePopoverOpen(null);
      }
    }
    if (
      isEditRecord &&
      event.target.localName !== "input" &&
      event.target.localName !== "div" &&
      event.target.className && // Ensure className exists
      typeof event.target.className === "string" && // Ensure className is a string
      !event.target.className.includes("fui-Dropdown__button")
    ) {
      handleBlur();
    } else if (isEditRecord && event.target.placeholder === "Search") {
      handleBlur();
    }
  };

  const handleScroll = (e) => {
    handlePopoverOpen(null);
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    window.addEventListener("wheel", handleScroll);
    document.addEventListener("keydown", handleEditable);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("wheel", handleScroll);
      document.removeEventListener("keydown", handleEditable);
    };
  }, [isEditRecord, popoverOpen]);

  ///////////////////////// FLAGGED fUNCTIONALITY /////////////////////////

  const addFlag = (id) => {
    setFlagged((prevItems) => [...prevItems, id]);
    updateFlag({
      id: id,
      payload: [
        {
          op: "replace",
          path: "/IsFlagged",
          value: true,
        },
      ],
    });
  };

  const removeFlag = (id) => {
    setFlagged((prevItems) => prevItems.filter((item) => item !== id));
    updateFlag({
      id: id,
      payload: [
        {
          op: "replace",
          path: "/IsFlagged",
          value: false,
        },
      ],
    });
  };

  useEffect(() => {
    const sortedArray = data;
    const tempDate = [...sortedArray];
    tempDate.push({
      name: "",
      client: null,
      owner: null,
      status: "",
      budget: 0,
      startDate: "",
      endDate: "",
      riskLevel: "",
    });
    setSortedData(tempDate);
  }, [flagged]);

  const sortDataByFlagged = (dataArray, flaggedArray) => {
    const flaggedItems = [];
    const remainingItems = [];

    dataArray.forEach((item) => {
      if (flaggedArray.includes(item.id)) {
        flaggedItems.push(item);
      } else {
        remainingItems.push(item);
      }
    });

    flaggedItems.sort((a, b) => {
      return flaggedArray.indexOf(a.id) - flaggedArray.indexOf(b.id);
    });

    return [...flaggedItems, ...remainingItems];
  };

  const handleInputChange = (value, type) => {
    let error = { ...formErrors };
    const data = JSON.parse(JSON.stringify(isEditRecord));
    if (type === "name") {
      error["name"] = ``;
      setFormErrors(error);
      data.name.name = value;
      setIsEditRecord(data);
    } else if (type === "client") {
      error["client"] = ``;
      setFormErrors(error);
      if (value) {
        if (!data?.name?.client) {
          data.name.client = {};
        }
        data.name.client.name = value.label;
        data.name.client.id = value.value;
      } else {
        data.name.client = null;
      }
      setIsEditRecord(data);
    } else if (type === "manager") {
      if (value) {
        if (!data?.name?.owner) {
          data.name.owner = {};
        }
        data.name.owner.name = value.label;
        data.name.owner.id = value.value;
      } else {
        data.name.owner = null;
      }
      setIsEditRecord(data);
    } else if (type === "budget") {
      data.name.budget = value;
      setIsEditRecord(data);
    } else if (type === "status") {
      data.name.status = value;
      setIsEditRecord(data);
    } else if (type === "riskLevel") {
      data.name.riskLevel = value;
      setIsEditRecord(data);
    } else if (type === "startDate") {
      data.name.startDate = value;
      setIsEditRecord(data);
    } else if (type === "endDate") {
      data.name.endDate = value;
      setIsEditRecord(data);
    }
  };

  const searchHandler = (value) => {
    if (value === "") {
      setResources([]);
      return;
    }
    userService
      .searchUserDataRequest(value)
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setResources(transformedArray);
      })
      .catch(() => {
        setResources([]);
      });
  };

  const searchClientHandler = (value) => {
    let error = { ...formErrors };
    error["client"] = ``;
    setFormErrors(error);
    if (value === "") {
      setClients([]);
      return;
    }
    clientService
      .searchClientsRequest(value)
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setClients(transformedArray);
      })
      .catch(() => {
        setClients([]);
      });
  };

  const handleIsEdiRecord = (index, type) => { 
    
    if (overviewType === "Dashboard") {
      return;
    }
    
    if (index === data.length && type !== "name") {
      sortedData[index] = {
        ...isEditRecord?.name,
      };
    }
    if (isEditRecord && isEditRecord.index === index) {
      focusField(type);
      return;
    }
    setIsEditRecord({ index: index, name: sortedData[index] });
    setTimeout(() => {
      focusField(type);
    }, 0);
  };

  const focusField = (type) => {
    switch (type) {
      case "name":
        portfolioNameInputRef.current?.focus();
        break;
      case "client":
        clientInputRef.current?.focus();
        break;
      case "budget":
        budgetInputRef.current?.focus();
        break;
      case "startDate":
        startDateInputRef.current?.focus();
        break;
      case "endDate":
        endDateInputRef.current?.focus();
        break;
      case "status":
        statusInputRef.current?.focus();
        break;
      case "manager":
        portfolioManagerInputRef.current?.focus();
        break;
      case "riskLevel":
        riskLevelInputRef.current?.focus();
        break;
      default:
        break;
    }
  };

  ///////////////////////// FLAGGED fUNCTIONALITY /////////////////////////

  const sortedColumnConfig = [...columnConfig].sort(
    (a, b) => a.order - b.order
  );

  const renderTableCell = (item, index, column) => {
    const isEditing = isEditRecord && isEditRecord.index === index;

    switch (column.label) {
      case "Portfolio":
        return (
          <TableCell className={isEditing ? "" : "hoverCell"}>
            <div className="d-flex justify-content-between inputWidth">
              <div className="d-flex align-items-center inputWidth">
                {item?.id && (
                  <Tooltip
                    positioning="before"
                    content={{
                      children: flagged.includes(item.id) ? "Unflag" : "Flag",
                      className: styles.tooltip,
                    }}
                    relationship="label"
                    withArrow
                  >
                    <span
                      className={`flag ${
                        flagged.includes(item.id) ? "flagActive" : ""
                      }`}
                      onClick={() =>
                        flagged.includes(item.id)
                          ? removeFlag(item.id)
                          : addFlag(item.id)
                      }
                    >
                      <FlagIcon />
                    </span>
                  </Tooltip>
                )}
                {isEditing ? (
                  <CustomInput
                    inputwd="inputWidth me-3"
                    icon={false}
                    placeholder="Add portfolio name"
                    value={isEditRecord.name.name}
                    type="text"
                    handleChange={(value) => handleInputChange(value, "name")}
                    ref={portfolioNameInputRef}
                    errorMessage={formErrors.name}
                    displayErrorMessage={false}
                  />
                ) : item?.id ? (
                  <span
                    className="d-flex w-full text-truncate"
                    onClick={() => handleRedirect(item)}
                  >
                    {item.isPendingDelete && <div className="mr-1"><PendingDeleteIcon/></div>}
                    {item.name}
                  </span>
                ) : (
                  <div
                    className="d-flex _add_btn"
                    onClick={() =>
                      handleIsEdiRecord(sortedData.length - 1, "name")
                    }
                  >
                    <PlusIcon />
                    Add
                  </div>
                )}
              </div>
              {item?.id && overviewType !== "Dashboard" && (
                <div className="flag">
                  <Popover
                    {...props}
                    open={popoverOpen === item.id}
                    onOpenChange={(isOpen) =>
                      isOpen && handlePopoverOpen(item.id)
                    }
                    positioning="below-start"
                  >
                    <PopoverTrigger disableButtonEnhancement>
                      <TableCellLayout
                        media={<MeatBallsMenuIcon />}
                        onClick={() => handleModal(item)}
                      />
                    </PopoverTrigger>
                    <PopoverSurface
                      tabIndex={-1}
                      className="listingPopoverWrapper"
                    >
                      {menu}
                    </PopoverSurface>
                  </Popover>
                </div>
              )}
            </div>
          </TableCell>
        );
      case "Client":
        return isEditing ? (
          <TableCell className={isEditing ? "" : "hoverCell"}>
            <CustomSelect
              SelectText="client"
              searchText={searchClientHandler}
              options={clients}
              defaultVal={
                isEditRecord.name.client
                  ? {
                      label: isEditRecord.name.client.name,
                      value: isEditRecord.name.client.id,
                    }
                  : null
              }
              onChange={(e) => handleInputChange(e, "client")}
              CustomClass="ModalAvatarSearch"
              errorMessage={formErrors.client}
              displayErrorMessage={false}
            />
          </TableCell>
        ) : item.client ? (
          <TableCell
            onClick={() => handleIsEdiRecord(index, "client")}
            className={isEditing ? "" : "hoverCell"}
          >
            <span {...(overviewType !== "Dashboard" && { onClick: () => handleClientRedirect(item) })}>
              {item.client?.name}
            </span>
          </TableCell>
        ) : (
          <TableCell />
        );
      case "Portfolio Manager":
        return (
          <TableCell
            role="gridcell"
            onClick={() => handleIsEdiRecord(index, "manager")}
          >
            {isEditing ? (
              <CustomSelect
                SelectText="manager"
                searchText={searchHandler}
                options={resources}
                defaultVal={
                  isEditRecord.name.owner?.name
                    ? {
                        label: isEditRecord.name.owner.name,
                        value: isEditRecord.name.owner.id,
                      }
                    : null
                }
                onChange={(e) => handleInputChange(e, "manager")}
                creatable={true}
                setCreated={setOwnerId}
                CustomClass="ModalAvatarSearch"
                handleInputChange={handleInputChange}
              />
            ) : item.owner?.name ? (
              <TableCellLayout
                media={
                  <HoverCard
                    HoverCardTrigger={
                      <Avatar
                        color="colorful"
                        name={item.owner?.name}
                        image={{ src: item.owner?.image }}
                      />
                    }
                    AvatarId={item.owner?.id}
                    AvatarName={item.owner?.name}
                    AvatarImage={item.owner?.image}
                    AvatarDesignation={item.owner?.title}
                    AvatarEmail={item.owner?.email}
                    AvatarPhone={item.owner?.phoneNumber}
                    AvatarIsExternal={item.owner?.isExternal}
                  />
                }
              >
                {item.owner?.name}
              </TableCellLayout>
            ) : (
              <TableCell />
            )}
          </TableCell>
        );
      case "Budget":
        return (
          <TableCell onClick={() => handleIsEdiRecord(index, "budget")}>
            {isEditing ? (
              <CustomInput
                icon={false}
                placeholder="0"
                value={isEditRecord.name.budget}
                type="number"
                currency={true}
                inline={true}
                handleChange={(value) => handleInputChange(value, "budget")}
                ref={budgetInputRef}
              />
            ) : item?.id ? (
              `${getAccountCurrency(setting)} ${displayDecimalFormatted(
                setting,
                item.budget
              )}`
            ) : (
              ""
            )}
          </TableCell>
        );
      case "Status":
        return (
          <TableCell onClick={() => handleIsEdiRecord(index, "status")}>
            {isEditing ? (
              <CustomInput
                icon={false}
                placeholder="Enter Status"
                value={isEditRecord.name.status}
                type="text"
                handleChange={(value) => handleInputChange(value, "status")}
                ref={statusInputRef}
              />
            ) : (
              item.status
            )}
          </TableCell>
        );
      case "Risk Level":
        return (
          <TableCell onClick={() => handleIsEdiRecord(index, "riskLevel")}>
            {isEditing ? (
              <CustomInput
                icon={false}
                placeholder="Enter risk level"
                value={isEditRecord.name.riskLevel}
                type="text"
                handleChange={(value) => handleInputChange(value, "riskLevel")}
                ref={riskLevelInputRef}
              />
            ) : (
              item.riskLevel
            )}
          </TableCell>
        );
      case "Start Date":
        return (
          <TableCell onClick={() => handleIsEdiRecord(index, "startDate")}>
            {isEditing ? (
              <CustomInput
                value={isEditRecord.name.startDate}
                type="date"
                handleChange={(value) => handleInputChange(value, "startDate")}
                ref={startDateInputRef}
                errorMessage={formErrors.startDate}
                displayErrorMessage={false}
              />
            ) : item.startDate ? (
              dateOnlyFormatted(setting, item.startDate)
            ) : (
              ""
            )}
          </TableCell>
        );
      case "End Date":
        return (
          <TableCell onClick={() => handleIsEdiRecord(index, "endDate")}>
            {isEditing ? (
              <CustomInput
                value={isEditRecord.name.endDate}
                type="date"
                handleChange={(value) => handleInputChange(value, "endDate")}
                ref={endDateInputRef}
                errorMessage={formErrors.endDate}
                displayErrorMessage={false}
              />
            ) : item.endDate ? (
              dateOnlyFormatted(setting, item.endDate)
            ) : (
              ""
            )}
          </TableCell>
        );
      case "Creation Date":
        return (
          <TableCell>
            {item.dateCreated
              ? utcToLocalDateString(setting, item.dateCreated)
              : ""}
          </TableCell>
        );
      default:
        return null;
    }
  };
  const styles = useStyles();

  const PortfolioRowSkeleton = ({ columnConfig, rowCount = 5 }) => {

  
    const skeletonRows = Array(rowCount).fill().map((_, rowIndex) => (
      <TableRow key={`skeleton-row-${rowIndex}`} className="skeleton-row">
        {columnConfig.map((col, colIndex) => (
          <TableCell
          >
            <Skeleton width={100} />
          </TableCell>
        ))}
      </TableRow>
    ));
  
    return <>{skeletonRows}</>;
  };
  if(loadingSkeleton) {
    return <PortfolioRowSkeleton columnConfig={columnConfig}/>;
  }
  return sortedData
  .filter(item => !(overviewType === "Dashboard" && !item.id))
  .map((item, index) => (
    <TableRow key={item.id || index} className="ProjectHover" ref={popoverRef}>
      {sortedColumnConfig
        .filter((col) => col.isVisible)
        .map((col) => renderTableCell(item, index, col))}
    </TableRow>
  ));
};

export default PortFolioRow;
